const prefix = 'nds-mc-question';

export const styles = {
	stem: `${prefix}__stem`,
	intro: `${prefix}__intro`,
	instructions: `${prefix}__instructions`,
	choiceLabel: `${prefix}__choice-label`,
	feedback: `${prefix}__feedback`,
	choice: `${prefix}__choice`,
};
